<template>
  <el-date-picker
    ref="control"
    class="ui-date-picker"
    :class="{ 'is-block': block }"
    :value="value"
    :popper-class="resolvedPopperClass"
    v-bind="localizedAttrs"
    v-on="forwardedListeners"
    @input="$emit('input', $event)"
  >
    <slot />
  </el-date-picker>
</template>

<script>
export default {
  name: 'UiDatePicker',
  inheritAttrs: false,
  props: {
    value: { default: '' },
    block: { type: Boolean, default: true },
    popperClass: { type: String, default: '' }
  },
  computed: {
    localizedAttrs () {
      const attrs = { ...this.$attrs }
      const key = attrs['picker-options'] ? 'picker-options' : 'pickerOptions'
      const options = attrs[key]
      if (options && options.shortcuts) {
        attrs[key] = { ...options, shortcuts: options.shortcuts.map(item => ({ ...item, text: this.$t(item.text) })) }
      }
      return attrs
    },
    resolvedPopperClass () {
      return ['terminal-dropdown-menu', 'terminal-picker-panel', 'terminal-date-picker', this.popperClass].filter(Boolean).join(' ')
    },
    forwardedListeners () {
      const listeners = { ...this.$listeners }
      delete listeners.input
      return listeners
    }
  },
  methods: {
    focus () {
      const input = this.$el && this.$el.querySelector('input')
      if (input) input.focus()
    },
    blur () {
      const input = this.$el && this.$el.querySelector('input')
      if (input) input.blur()
    }
  }
}
</script>

<style lang="scss">
.ui-date-picker {
  height: var(--ui-control-height);
  box-sizing: border-box;
  vertical-align: top;
}

.ui-date-picker.is-block {
  width: 100% !important;
}

.ui-date-picker.el-input,
.ui-date-picker.el-range-editor {
  height: var(--ui-control-height);
  border-color: var(--ui-control-rest-border);
  border-radius: var(--ui-radius-medium);
  background: linear-gradient(var(--ui-control-rest-background), var(--ui-control-rest-background)), var(--ui-bg-control);
}

.ui-date-picker .el-input__inner {
  height: var(--ui-control-height);
  color: var(--ui-text-primary);
  border-color: var(--ui-control-rest-border);
  border-radius: var(--ui-radius-medium);
  background: linear-gradient(var(--ui-control-rest-background), var(--ui-control-rest-background)), var(--ui-bg-control);
  font-size: var(--ui-font-size-form-control);
  line-height: var(--ui-control-height);
}

.ui-date-picker .el-input__inner::placeholder,
.ui-date-picker .el-range-input::placeholder {
  color: var(--ui-control-rest-placeholder);
}
</style>
